// extracted by mini-css-extract-plugin
module.exports = {"container":"Walktrough_container__1S6ku","limiter":"Walktrough_limiter__2WxT9","wrapper":"Walktrough_wrapper__24CJw"};